// extracted by mini-css-extract-plugin
module.exports = {"workshow":"WorkShow-module--workshow--1ctvX"};